const isNegative = n => n < 0;

export { isNegative };
